import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { format, parseISO } from 'date-fns';
import { ModalContainer } from '@surfline/quiver-react';
import ContestEntry from '../ContestEntry';
import contestEntryPropType from '../../propTypes/contestEntry';
import createAccessibleOnClick from '../../utils/createAccessibleOnClick';

class ContestEntryCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        isOpen: false,
        entry: null,
      },
    };
  }

  toggleModal = (entry) => {
    const { modal } = this.state;
    this.setState({
      modal: {
        isOpen: !modal.isOpen,
        entry,
      },
    });
  }

  render() {
    const { entry, doTrackEvent, region, period } = this.props;
    const { modal } = this.state;
    return (
      <div className="sl-contest-entry-card">
        <div {...createAccessibleOnClick(() => this.toggleModal(entry))}>
          <div className="sl-contest-entry-card__date">#{entry.entryId}</div>
          <div className="sl-contest-entry-card__video">
            <div style={{ backgroundImage: `url(${entry.posterUrl})` }} />
          </div>
          <div className="sl-contest-entry-card__details">
            <h5>{entry.name}</h5>
            <div className="sl-contest-entry-card__details__tags">
              <p className="sl-contest-entry-card__details__tags__spot">{entry.spot.name}</p>
              <p>{format(parseISO(entry.date), 'MMMM dd')}</p>
            </div>
          </div>
        </div>
        <ModalContainer
          isOpen={modal.isOpen}
          contentLabel={entry.surfer ? entry.surfer.name : null}
          onClose={this.toggleModal}
          location="contest-entry"
        >
          <div className="sl-contest-modal">
            <ContestEntry
              entry={entry}
              doTrackEvent={doTrackEvent}
              period={period}
              region={region}
            />
          </div>
        </ModalContainer>
      </div>
    );
  }
}

ContestEntryCard.propTypes = {
  entry: contestEntryPropType.isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  period: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
};

export default ContestEntryCard;
